import React from "react";
import { IconButton } from "@mui/material";
import './labelledIconButton.sass';

interface ComponentProps {
    label: string | React.ReactElement;
    icon: React.ReactElement;
    onClick: () => void;
}

const LabelledIconButton: React.FunctionComponent<ComponentProps> = props => {
    const { icon, label } = props;

    return (
        <div className="labelled-icon-container">
            <IconButton 
                className="labelled-icon-button"
                onClick={props.onClick} 
                sx={{
                    ":hover": {
                        backgroundColor: "#F2F2EF"
                    }
                }}>
                {icon}
            </IconButton>
            {label}
        </div>
    );
 }

 export default (LabelledIconButton);